
import { Component, Prop, Vue } from "vue-property-decorator";
import Table from "@/domain/restaurant/Table";
import TableDialog from "@/components/restaurant/table/TableDialog.vue";
@Component({
  components: { TableDialog }
})
export default class TableCard extends Vue {
  @Prop({
    default: () => {
      return new Table();
    }
  })
  table!: Table;

  tableAvailabilityDisplayNames = Table.tableAvailabilityDisplayNames();

  tablePreferenceDisplayNames = Table.tablePreferenceDisplayNames();

  get tableAvailabilityColour() {
    return Table.getTableAvailabilityColour(this.table);
  }

  get tablePreferenceColour() {
    return Table.getTablePreferenceColour(this.table);
  }

  get joinedTable() {
    return this.table.joinedTableComponents.length !== 0;
  }

  emitTableSelected() {
    this.$emit("table-selected", this.table);
  }
}
